import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonWithArrowRight, Footer } from '~components';
import House from '~components/svgs/House';
import User from '~components/svgs/User';
import UserFrame from '~components/svgs/UserFrame';
import { useLayout } from '~hooks';
import ScreenWarning from '../../../components/dumbs/ScreenWarning';
import * as Styled from './styled';

function SendDocumentsAndSelfie() {
  const { setLayout } = useLayout();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
  };

  useEffect(() => {
    setLayout({
      header: {
        title: 'Envio de documentos e selfie',
        subtitle:
          'Nesta etapa cada representante precisará enviar a foto de alguns documentos e tirar uma selfie.',
      },
    });
  }, []);

  return (
    <Styled.Container>
      <Styled.Section>
        <Styled.DocumentsAndSelfie />
        <Styled.ColumnDescription>
          <Styled.TitleDescription>
            Um SMS com um link foi enviado para o celular dos representantes e
            eles precisarão:
          </Styled.TitleDescription>
          <Styled.ListDescription>
            <Styled.ListItemGroup>
              <User />
              <Styled.ListItemDescription>
                Tirar uma foto do RG ou CNH
              </Styled.ListItemDescription>
            </Styled.ListItemGroup>
            <Styled.ListItemGroup>
              <House />
              <Styled.ListItemDescription>
                Tirar uma foto do comprovante de residência
              </Styled.ListItemDescription>
            </Styled.ListItemGroup>
            <Styled.ListItemGroup>
              <UserFrame />
              <Styled.ListItemDescription>
                Também será solicitado que você tire uma foto sua (selfie)
              </Styled.ListItemDescription>
            </Styled.ListItemGroup>
          </Styled.ListDescription>
          <ScreenWarning message="O envio de todos os documentos e selfie é obrigatório para todos os representantes." />
        </Styled.ColumnDescription>
      </Styled.Section>
      <Footer
        marginTop="auto"
        marginTopSM="48px"
        havePaddingBottomSM
        rightButton={
          <ButtonWithArrowRight
            width="100%"
            variant="primary"
            onClick={handleClick}
          >
            Continuar
          </ButtonWithArrowRight>
        }
      />
    </Styled.Container>
  );
}

export default SendDocumentsAndSelfie;
